import { useFeatureFlag } from './useFeatureFlag';
import { useSelector } from 'react-redux';

import { enableReportsManager } from '../constants/featureFlag';
import { jsonStringToObject } from '../utils/common';
import { analyticsMenuItems, analyticsMenuItemsWithReportsManager } from '../constants/navigationPanel';

export function useReportsManager() {
  const currentUser = useSelector((state) => state.role.user);
  const allowAllUsers = useFeatureFlag(enableReportsManager, false, true);
  const allowedReportsManagerEmails = useFeatureFlag(enableReportsManager, JSON.stringify([]));
  const userId = currentUser?.id;

  if (!userId) return { isReportsManagerEnabled: false, sidebarMenuItems: analyticsMenuItems };

  if (allowAllUsers) {
    return {
      isReportsManagerEnabled: true,
      sidebarMenuItems: analyticsMenuItemsWithReportsManager,
    };
  }

  const authorizedUserIds = jsonStringToObject(allowedReportsManagerEmails, []);
  const isReportsManagerEnabled = Array.isArray(authorizedUserIds) && authorizedUserIds.includes(userId);

  return {
    isReportsManagerEnabled,
    sidebarMenuItems: isReportsManagerEnabled ? analyticsMenuItemsWithReportsManager : analyticsMenuItems,
  };
}
